var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-my",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.4 42.5h511.2v41H.4zM.4 126.5h511.2v41H.4zM.4 210.6h511.2v41H.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h256v298.7H0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m172.5 86.8 5.6 38.2 21.6-32-11.6 36.8 33.3-19.4-26.4 28.1 38.5-3-36 13.8 36 14-38.5-3.1 26.4 28L188 169l11.6 36.7-21.6-31.9-5.6 38.1-5.6-38-21.5 31.8 11.5-36.7-33.2 19.4 26.3-28.1-38.4 3 36-13.9-36-13.9 38.4 3.1-26.3-28.1 33.2 19.4L145.4 93l21.5 32zm-31.2 1.6a66.7 66.7 0 1 0 0 121.9 75 75 0 1 1 0-121.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.4 294.6h511.2v41H.4zM.4 378.1h511.2v41H.4zM0 471h511.2v41H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.fdbf34d612e2474b2a7fa324baacd31d.svg";
export { ForwardRef as ReactComponent };